import { forwardRef } from 'react';

import { TProps } from '../types/TProps';
import { NeutralButtonChrome } from './NeutralButtonChrome';

export const AdminJobTopActionButton = forwardRef<HTMLButtonElement, TProps>(({ className, ...props }, ref) => (
  <NeutralButtonChrome ref={ref} className={['btn--admin-top', className].filter(Boolean).join(' ')} {...props} />
));

AdminJobTopActionButton.displayName = 'AdminJobTopActionButton';
